import client from './client'
import { buildListParams } from '../utils/pagination'

export function fetchComments(trackId, { page, perPage } = {}) {
  const params = buildListParams({ page, perPage })
  return client.get(`/api/v1/tracks/${trackId}/comments`, { params })
}

export function fetchPublicTrackComments({ page, perPage } = {}) {
  const params = buildListParams({ page, perPage })
  return client.get('/api/v1/public_track_comments', { params })
}

export function createComment(trackId, formData) {
  return client.post(`/api/v1/tracks/${trackId}/comments`, formData)
}

export function deleteComment(trackId, commentId) {
  return client.delete(`/api/v1/tracks/${trackId}/comments/${commentId}`)
}

export function updateCommentsSettings(trackId, allowComments) {
  return client.patch(`/api/v1/tracks/${trackId}/comments_settings`, {
    allow_comments: allowComments,
  })
}
